import { TOption } from 'components/OWForm/OWSelect'

export const SupportLanguages: TOption[] = [
    { value: 'en', label: 'English' },
    { value: 'th', label: 'ภาษาไทย' },
]
